import { ActivatedRouteSnapshot, ResolveFn, Route, RouterStateSnapshot } from '@angular/router';
import { USER_LIST_PATH, USER_LIST_TITLE } from '../../mgs-path-defs';
import { mgsAdminGuard } from '../../mgs-guards';
import { inject } from '@angular/core';
import { UserService } from '../user.service';
import { mgsIconsResolver } from '../../mgs-svg-icon.helper';
import { partnerResolver } from '../../partner/partner.resolver';

export const userResolver: ResolveFn<void> = async (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const userService = inject(UserService);
  return userService.loadUsers();
};

export const userListRoute: Route = {
  path: USER_LIST_PATH,
  resolve: { users: userResolver, partner: partnerResolver, icons: mgsIconsResolver },
  title: USER_LIST_TITLE,
  canActivate: [mgsAdminGuard],
  loadComponent: () => import('./user-list-container.component').then((c) => c.UserListContainerComponent)
};
